import { render, staticRenderFns } from "./blood-donation.vue?vue&type=template&id=544f256e&scoped=true"
import script from "./blood-donation.vue?vue&type=script&lang=js"
export * from "./blood-donation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "544f256e",
  null
  
)

export default component.exports